import React from 'react';
import PropTypes from 'prop-types';
import Order from './Order';
import { addResourceStrings, translateResourceString } from '../util/translationUtility';
import fetch from 'cross-fetch';

class Reorder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orderCount: props.OrderCount,
            orders: [],
            page: 0,
            pageSize: 10
        };

        addResourceStrings(props.LocalizationItems);
    }

    componentDidMount() {
        require('./reorderApp.css');
        this.loadMore();
    }

    loadMore = () => {
        let skip = this.state.page * this.state.pageSize;

        fetch(`${this.props.OrdersApiEndpoint}?skip=${skip}&take=${this.state.pageSize}`)
            .then(response => response.json())
            .then(json => this.setState(prevState => {
                return {
                    orders: prevState.orders.concat(json),
                    page: prevState.page + 1
                }
            }));
    }

    render() {
        const { orders } = this.state;

        const showLoadMore = this.state.page * this.state.pageSize < this.state.orderCount;

        return (
            <div className="reorder-container mb-2">
                {orders.map((order, i) =>
                    <Order
                        key={i}
                        {...order}
                        {...this.props}
                        startOpen={i === 0}
                    />
                )}
                {showLoadMore &&
                    <div className="text-center">
                        <button className={"btn btn-secondary"} onClick={this.loadMore}>{translateResourceString("/Reorder/LoadMoreButton")}</button>
                    </div>
                }
            </div>
        );
    }
}

Reorder.propTypes = {
    OrdersApiEndpoint: PropTypes.string,
    ProductsApiEndpoint: PropTypes.string,
    AddToCartEndpoint: PropTypes.string,
    OrderCount: PropTypes.number
};

export default Reorder;